<template>
    <el-button  icon="el-icon-refresh" v-on:click="clickEvent()">重置</el-button>
</template>
  
  <script>
  
  export default {
    name: 'reset-button',
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// ResetButton.vue?64ef3b88